import { createContext, useContext } from 'react';

// Shared with ToastContext.jsx, which provides the value and renders the
// toast stack. Split into its own file (react-refresh's "only export
// components" rule wants a component file to export components alone) so
// useToast lives somewhere other than the ToastProvider component itself.
export const ToastCtx = createContext(null);

export function useToast() {
  const ctx = useContext(ToastCtx);
  if (!ctx) throw new Error('useToast must be used within a ToastProvider');
  return ctx;
}

// Module-level singleton, same "far-apart consumers, no context wiring worth
// it" reasoning builder/advancedControls.js already takes: App.jsx (the only
// place that knows how to open the billing panel, and whether the current
// user is even an org admin allowed to) registers this on mount/on
// isOrgAdmin change; ToastContext.jsx's error() reads it via getUpgradeHandler.
// Lets EVERY existing toast.error(err) call site across the app automatically
// grow an "Upgrade" action the moment its error body carries cap_exceeded
// (billing.py's PLAN_CAPS['free'] trial-expiry gate), with zero changes at
// each call site.
let upgradeHandler = null;
export function setUpgradeHandler(fn) { upgradeHandler = fn; }
export function getUpgradeHandler() { return upgradeHandler; }
